/** Status badge for race entry status — DNF, DSQ, DNS, etc. */

interface StatusBadgeProps {
  status: string;
}

const STATUS_STYLES: Record<string, { bg: string; text: string; border: string }> = {
  DNF: { bg: 'rgba(248, 113, 113, 0.10)', text: '#f87171', border: 'rgba(248, 113, 113, 0.25)' },
  DSQ: { bg: 'rgba(248, 113, 113, 0.10)', text: '#f87171', border: 'rgba(248, 113, 113, 0.25)' },
  DNS: { bg: 'rgba(250, 204, 21, 0.10)', text: '#facc15', border: 'rgba(250, 204, 21, 0.25)' },
  PEN: { bg: 'rgba(250, 204, 21, 0.10)', text: '#facc15', border: 'rgba(250, 204, 21, 0.25)' },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const upper = status.toUpperCase();

  // "Finished" or "OK" — no badge needed
  if (upper === 'FINISHED' || upper === 'OK' || upper === '') return null;

  const style = STATUS_STYLES[upper] ?? {
    bg: 'rgba(156, 163, 175, 0.10)',
    text: '#9b9ca7',
    border: 'rgba(156, 163, 175, 0.2)',
  };

  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase mono tracking-wider"
      style={{
        background: style.bg,
        color: style.text,
        border: `1px solid ${style.border}`,
      }}
    >
      {upper}
    </span>
  );
}
